/**
 * One rule for when the floating order bar appears, and whether it looks like a live
 * cart or a way back into recent previous orders.
 *
 * Port of iOS `OrderNowBarVisibility.swift`. It is a separate unit for the reason it is
 * one there: THREE call sites need the identical answer — the bar itself, and the two
 * getters in `menu.component.ts` that reserve room for it. A copy of the condition in
 * the layout is how the bar ends up drawn on top of the last product row, which is
 * exactly the bug that appears the moment the bar can show with an empty cart.
 */

export type OrderBarAppearance = 'cart' | 'previousOrders';

/**
 * The bar is reachable while the guest has something in the cart OR an order recent
 * enough to still be worth returning to.
 *
 * The second half is the change: once a submitted order cleared the cart, the guest had
 * no route back to it at all.
 */
export function shouldShowOrderBar(hasCartItems: boolean, hasRecentOrders: boolean): boolean {
  return hasCartItems || hasRecentOrders;
}

/**
 * A live cart always wins the bar. Recent orders are what it falls back to, so a guest
 * who starts adding items again immediately sees their cart rather than their history.
 */
export function orderBarAppearance(hasCartItems: boolean): OrderBarAppearance {
  return hasCartItems ? 'cart' : 'previousOrders';
}
